import React from 'react';
export const library = {
  libraryID: 1,
};

export const LibraryContext = React.createContext( library.libraryID );
